import { Component, OnInit } from '@angular/core';

import { SharedService } from "./../../../shared/shared.service";
import { AdminDevoteeService } from './../../services/admin-devotee.service';
import { DevoteeDetail } from "./../../../devotee/devotee-detail";
import { PagingGridData } from "./../../models/paging-grid-data";


@Component({
  selector: 'app-devotee-address-print2',
  templateUrl: './devotee-address-print2.component.html',
  styleUrls: ['./devotee-address-print2.component.css'],
  providers: [AdminDevoteeService]
})
export class DevoteeAddressPrint2Component implements OnInit {

  constructor(private sharedService: SharedService,
    private adminDevoteeService: AdminDevoteeService) { }

  devoteeList: DevoteeDetail[] = [];
  errorMessage: string = "";

  ngOnInit() {
    this.pageChanged(1);
  }

  pageChanged(pageNo: number) {

    this.sharedService.showSpinner();
    this.adminDevoteeService.getDevotee().subscribe(
      data => {
        console.log(data);
        this.devoteeList = data;
      },
      err => this.errorMessage = err,
      () => this.sharedService.hideSpinner()
    )

  }

  // getDevoteeDetail():DevoteeDetail{
  //   return {
  //     AddressLine1:""
  //   };
  // }


  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <!-- Latest compiled and minified CSS -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous">

<!-- Optional theme -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap-theme.min.css" integrity="sha384-rHyoN1iRsVXV4nD0JutlnGaslCJuC7uwjduW9SVrLvRYooPp2bWYgmgJQIXwl/Sp" crossorigin="anonymous">


          <style>
          //........Customized style.......
  
.pagebody {
        width: 8.5in;
        margin: 0in .1875in;
        margin-top:40px;
        }

.boxlabel{
        /* Avery 5160 labels -- CSS and HTML by MM at Boulder Information Services */
        width: 2.51in; /* plus .6 inches from padding */
        height: 1.57in; /*.875in; /* plus .125 inches from padding */
        padding: 2px .1in 0;
        margin-right: .125in; /* the gutter */
        margin-bottom: 10px;
        font-size: 14px;
        float: left;
        /*text-align: center;*/
        overflow: hidden;
        outline: 1px dotted; /*outline doesn't occupy space like border does border-bottom: 1px dotted */
        color: black;
        }

    .page-break  {
        clear: left;
        display:block;
        page-break-after:always;
    }
          </style>

          <!-- Latest compiled and minified JavaScript -->
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js" integrity="sha384-Tc5IQib027qvyjSMfHjOMaLkfuWVxZxUPnCJA7l2mCWNIpG9mGCD8wGNIcPD7Txa" crossorigin="anonymous"></script>
            
       
        </head>
    <body >${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

}




// WEBPACK FOOTER //
// ./src/app/admin/components/devotee-address-print2/devotee-address-print2.component.ts